// extracted by mini-css-extract-plugin
export default {"list":"vOkSe","item":"Xo0qH","iconContainer":"L14Sr","link":"KoUho","linkSelected":"bucVN"};